import { memo } from "react";
import { Select, SelectProps } from "antd";

const OrganizationSelect = memo(
  ({ value, defaultValue, ...rest }: SelectProps & { value?: string }) => (
    <Select
      allowClear
      onClear={rest.onClear}
      listItemHeight={60}
      notFoundContent={null}
      filterOption={false}
      showSearch
      optionLabelProp="inputLabel"
      popupClassName="organization-suggestions-popup"
      placeholder="Введите название или ИНН"
      {...rest}
      value={value}
      defaultValue={defaultValue}
    />
  ),
);

export default OrganizationSelect;
